"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProductsStoreDiscount = exports.getProductIsolatedStoreDiscount = exports.getProductStoreDiscount = void 0;
const product_bulk_discount_1 = require("./product-bulk-discount");
const _shared_1 = require("../shared");
const discounts_helper_1 = require("./discounts-helper");
const calculateProductStoreDiscount = (discountedProduct, storeDiscountPercentage) => {
    const lineItemSubtotal = discountedProduct.lineItemSubtotal;
    const subtotal = lineItemSubtotal - discountedProduct.discounts.bulk.discountAmount;
    const discountAmount = subtotal * (0, _shared_1.convertDBToRate)(storeDiscountPercentage);
    const discountedTotal = subtotal - discountAmount;
    // console.log('>>> calculateProductStoreDiscount: ', discountedProduct, storeDiscountPercentage, lineItemSubtotal, subtotal, discountAmount, discountedTotal);
    return Object.assign(Object.assign({}, discountedProduct), { subtotal: discountedTotal, total: discountedTotal, discounts: Object.assign(Object.assign({}, discountedProduct.discounts), { store: {
                subtotal,
                discountAmount,
                total: discountedTotal
            } }) });
};
/**
 * Calculates a single product store discount (e.g: *Buy more than 30€ and get 10% OFF*).
 * It does not validate the minimum order amount to apply the discount.
 *
 * Note: Applies both the direct and bulk discounts before calculating the store discount.
 */
const getProductStoreDiscount = (product, storeDiscountPercentage) => {
    const discountedProduct = (0, product_bulk_discount_1.getProductBulkDiscount)(product);
    // console.log(' bulk discountedProduct: ', discountedProduct);
    return calculateProductStoreDiscount(discountedProduct, storeDiscountPercentage);
};
exports.getProductStoreDiscount = getProductStoreDiscount;
/**
 * Calculates a single product store discount (e.g: *Buy more than 30€ and get 10% OFF*) without considering the direct and bulk discounts.
 * It does not validate the minimum order amount to apply the discount.
 */
const getProductIsolatedStoreDiscount = (product, storeDiscountPercentage, lineItemSubtotal) => {
    // console.log('product: ', product);
    const discountedProduct = (0, discounts_helper_1.buildEmptyDiscountedProduct)(product.productId);
    discountedProduct.lineItemSubtotal = lineItemSubtotal;
    // console.log('discountedProduct: ', discountedProduct);
    return calculateProductStoreDiscount(discountedProduct, storeDiscountPercentage);
};
exports.getProductIsolatedStoreDiscount = getProductIsolatedStoreDiscount;
/**
 * Calculates a list of products bulk discount. See the `getProductStoreDiscount`
 * method description for more details.
 */
const getProductsStoreDiscount = (products, storeDiscountPercentage) => products.reduce((acc, product) => {
    const discountedProduct = (0, exports.getProductStoreDiscount)(product, storeDiscountPercentage);
    // console.log('>>> discountedProduct: ', discountedProduct);
    return (0, discounts_helper_1.buildProductsDiscountSummary)(acc, discountedProduct);
}, { products: [], lineItemSubtotal: 0, subtotal: 0, total: 0, discounts: { direct: 0, bulk: 0, store: 0 } });
exports.getProductsStoreDiscount = getProductsStoreDiscount;
